import { render } from "./AcademicCompetencyBasicDataTab.vue?vue&type=template&id=0215996a&ts=true"
import script from "./AcademicCompetencyBasicDataTab.vue?vue&type=script&lang=ts"
export * from "./AcademicCompetencyBasicDataTab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__